module.exports = __webpack_public_path__ + "static/media/4.a9861e0d.png";